import { useAuthStore } from '@/store/auth-store'

function getCsrfToken(): string {
  const match = document.cookie.match(/csrf_access_token=([^;]+)/)
  return match ? match[1] : ''
}

export const authService = {
  async login(email: string, password: string) {
    const res = await fetch('/api/auth/login', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    })
    const data = await res.json()
    if (!res.ok) throw new Error(data.message || data.error || 'Identifiants incorrects')
    if (data.requires_2fa) throw new Error('2FA non supporte sur cette interface')
    return data
  },

  async refresh() {
    const res = await fetch('/api/auth/refresh', {
      method: 'POST',
      credentials: 'include',
      headers: { 'X-CSRF-TOKEN': getCsrfToken() },
    })
    if (!res.ok) {
      useAuthStore.getState().logout()
      throw new Error('Session expiree')
    }
    return res.json()
  },

  async logout() {
    useAuthStore.getState().logout()
  },
}
